module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": _vm.submitForm
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-secondary",
      "title": "Terug",
      "exact": "",
      "to": {
        name: 'categoryList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })]), _vm._v(" "), (_vm.mode == 'edit') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Categorie aanpassen")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Categorie toevoegen")]) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('h2', [_vm._v(_vm._s(_vm.form.title))]) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), (!_vm.isFetching) ? _c('div', [(_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Titel:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.slugTitle),
      callback: function($$v) {
        _vm.slugTitle = $$v
      },
      expression: "slugTitle"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Afkorting:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.abbreviation),
      callback: function($$v) {
        _vm.$set(_vm.form, "abbreviation", $$v)
      },
      expression: "form.abbreviation"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Code:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.slug),
      callback: function($$v) {
        _vm.$set(_vm.form, "slug", $$v)
      },
      expression: "form.slug"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": _vm.$t('category.startTime')
    }
  }, [_c('datetime', {
    attrs: {
      "type": "datetime",
      "input-class": "form-control",
      "value-zone": "local"
    },
    model: {
      value: (_vm.form.auction_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "auction_date", $$v)
      },
      expression: "form.auction_date"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": _vm.$t('category.startAuctionOrderNumber')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.start_auction_order_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_auction_order_number", $$v)
      },
      expression: "form.start_auction_order_number"
    }
  })], 1), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.form.hidden),
      callback: function($$v) {
        _vm.$set(_vm.form, "hidden", $$v)
      },
      expression: "form.hidden"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('category.hiddenCategory')) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Beschrijving:"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 7
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.mode == 'edit') ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": "Opslaan"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": "Categorie aanmaken"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })]) : _vm._e()], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12b8eded"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Category/CategoryForm.vue
// module id = 1279
// module chunks = 1